<div class="w-100" *ngIf="dataSource && dataSource.data.length > 0; else noContact">
  <!-- filter -->
  <!-- <div class="d-flex flex-column flex-sm-row">
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtre" />
    </mat-form-field>
  </div>-->
  <!-- TABLE -->
  <div [class]="tableClass">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.name }}</td>
      </ng-container>
      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Resume</th>
        <td mat-cell *matCellDef="let row">{{ row.summary }}</td>
      </ng-container>
      <ng-container matColumnDef="fullAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Adresse</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.address | fullAddress }}</td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator"><a [href]="'mailto:'+row.email">{{
            row.email }}</a></td>
      </ng-container>
      <ng-container matColumnDef="phoneNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tel.</th>
        <td mat-cell *matCellDef="let row"><a *ngIf="row.phoneNumber" [href]="'tel:'+row.phoneNumber">{{ row.phoneNumber
            }}</a></td>
      </ng-container>
      <ng-container matColumnDef="website">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Site web</th>
        <td mat-cell *matCellDef="let row" class="no-mobile"><a [href]="row.webSite" target="_blank"
            rel="noopener noreferrer">{{row.webSite}}</a></td>
      </ng-container>
      <!-- <ng-container matColumnDef="contact">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact</th>
        <td mat-cell *matCellDef="let row">
          <span class="mobile-label">Contact</span>
          <button mat-flat-button color="primary" class=""
            (click)="doContact(row.name, row.uid)">Contacter</button>
        </td>
      </ng-container> -->

      <ng-container matColumnDef="actions" *ngIf="canUpdateProperty">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
<ng-template #noContact>
  <span class="no-content">Aucun service n'est renseigné</span>
</ng-template>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li>
        <a (click)="edit(row)"><mat-icon color="primary">create</mat-icon><span class="text">Modifier le
            service</span></a>
      </li>
      <li>
        <a (click)="confirmDelete(row)">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer le service</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>